(function() {

  var dropBtns = document.querySelectorAll('.dropdown');
  var openMenus = document.querySelectorAll('.dropdown-nav');
  
  function closeOpenItems() {
      openMenus = document.querySelectorAll('.dropdown');
      openMenus.forEach(function(menus) {
        menus.classList.remove('open');
		//menus.children.setAttribute('aria-expanded', "false");
      });  
  }

  dropBtns.forEach(function(btn) {

    btn.addEventListener('click', function(e) {
      var 
        dropContent = btn.querySelector('.dropdown-nav'),
        shouldOpen = !this.classList.contains('open');
		// e.preventDefault(); this causes dropdown links not to work?

      // First close all open items.
      closeOpenItems();
      // Check if the clicked item should be opened. It is already closed at this point so no further action is required if it should be closed.
      if (shouldOpen) {
        // Open the clicked item.
        this.classList.add('open');      
		this.children[0].setAttribute('aria-expanded', "true");
      } else {
		this.children[0].setAttribute('aria-expanded', "false");
	  }
      e.stopPropagation();
    });


  });

  //   close menus when clicking outside of them
  window.addEventListener('click', function(event) {
    if (event.target != dropBtns) {
      // Moved the code here to its own function.
      closeOpenItems();
    }
  });

})();